import { createSelector } from '@reduxjs/toolkit';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectResolvedPathname } from 'src/redux/navigation/selectors';
import { shopSurfaceBasePath } from 'src/utils/shopSurfaceBasePath';

const selectSurface = (state: ReduxApplicationState) => state.productsQuery.surface;

/**
 * True when the current shop (taxonomy) route is the surface root — e.g.
 * `/shop/all` — with no taxonomy/product-type level in the URL.
 *
 * Derived from the URL rather than the loaded facets so it stays stable during
 * client navigation: the "all products" state is never briefly shown while a
 * deeper page's facets are still syncing. Naturally scoped to the shop route,
 * since `surface` is only set there.
 */
export const selectIsShopSurfaceRoot = createSelector(
  [selectResolvedPathname, selectSurface],
  (pathname, surface): boolean => {
    const basePath = shopSurfaceBasePath(surface);

    if (!basePath) {
      return false;
    }

    return pathname.replace(/\/+$/, '') === basePath;
  },
);
